module.exports = __webpack_public_path__ + "static/media/notifications.53af05b7.svg";